import { useState, useEffect } from "react";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import * as Yup from "yup";
import { ImageDrawer } from "./ImageDrawer";
import { history } from "../../../../shared/_helpers/history";
import LeftArrow from "../../../../assets/icons/left-arrow.png";
import AddImg from "../../../../assets/add-img.svg";
import TrashIcon from "../../../../assets/icons/ic_delete.svg";
import InfoIcon from "../../../../shared/components/icons/InfoIcon";
import { Formik, FormikProps, Form, Field, ErrorMessage } from "formik";
import { allowNumbersOnly, numberWithCommas } from "../../../../shared/utils";
import DatePicker from "react-datepicker";
import { AlertMsg } from "../../../../shared/components/alert-msg";
import { MultiSelect } from "react-multi-select-component";
import { LoadingItem } from "../../../../shared/components/loading";
import { useToast } from "../../../../shared/context/ToastContext";
import {
  EditableProductAttribute,
  Variant,
} from "../../../../types/ProductTypes";
import {
  buildProductPayload,
  calculateDiscountPercent,
  calculateDiscountedPrice,
  getRequestErrorMessage,
  getProductSubmissionErrors,
  parseMoneyInput,
} from "../../../../modules/inapp/products/utils/productPayload";
import ProductVarianceModal from "./ProductVarianceModal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// const uploadImagesData: any[] = [];
const sizeofFetch = 8;

const getMetadata = async ({ pageProps, payload }: any) => {
  await pageProps.getMetadataAction(payload);
};

const addNewProduct = async ({ pageProps, payload }: any) => {
  await pageProps.createProductAction(payload);
};

const uploadProductImage = async ({ pageProps, payload, otherNames }: any) => {
  await pageProps.uploadProductImageAction(payload, otherNames);
};

const getImagesGallery = async ({ pageProps, payload }: any) => {
  await pageProps.getImageGalleryAction(payload, false);
};

export const InAppContent = ({ pageProps }: any) => {
  const { showToast } = useToast();
  const screenResolution: any = useWindowSize();
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [showCatError, setShowCatError] = useState(false);
  const [schemaErrors, setSchemaErrors] = useState<string[]>([]);
  const [selectedImagesStore, setSelectedImagesStore] = useState<any[]>([]);
  const [selecteCatsStore, setSelecteCatsStore] = useState<any[]>([]);
  const [catListItems, setCatListItems] = useState<any>();
  const [uploadImagesData, setUploadImagesData] = useState<any[]>([]);
  const [attributes, setAttributes] = useState<EditableProductAttribute[]>([]);
  const [variants, setVariants] = useState<Variant[]>([]);
  const [showAddEditVariantPopup, setShowAddEditVariantPopup] =
    useState<boolean>(false);
  const [editingVariantIndex, setEditingVariantIndex] = useState<number | null>(
    null,
  );
  const [variantToEdit, setVariantToEdit] = useState<Variant | null>(null);
  const [productNameForVariants, setProductNameForVariants] = useState("");

  const [allCatsList, setAllCatsList] = useState<any[]>([]);
  const [allCatsSelected, setAllCatsSelected] = useState<any[]>([]);
  const [startDate, onStartChange] = useState<any>();
  const [endDate, onEndChange] = useState<any>();
  const [isTaxableOption, setIsTaxable] = useState(false);
  const [isDiscountMore, setIsDiscountMore] = useState(false);
  const [wholesaleProduct, setWholesaleProduct] = useState(false);
  const [availability, setAvailability] = useState("0");
  const [orderCutOffDate, setOrderCutOffDate] = useState<any>(null);
  const [expectedAvailabilityDate, setExpectedAvailabilityDate] = useState<any>(null);
  const [showOrderCutoffTooltip, setShowOrderCutoffTooltip] = useState(false);
  const [showExpectedAvailabilityTooltip, setShowExpectedAvailabilityTooltip] = useState(false);
  // const otherData =
  let imagesChosen: any = [];

  const modules = {
    toolbar: [
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image", "link"],
    ],
  };

  const formats = [
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "align",
    "list",
    "bullet",
    "image",
    "link",
  ];
  useEffect(() => {
    setShowCatError(false);
    setAllCatsSelected([]);

    getMetadata({
      pageProps,
      // payload: "CLEAR"
    }).then(() => { });

    getImagesGallery({
      pageProps,
      payload: "CLEAR",
    });
    addNewProduct({
      pageProps,
      payload: "CLEAR",
    });
  }, []);

  useEffect(() => {
    if (
      pageProps.getProductMetaDataRequest.request_status ===
      "GET_PRODUCT_META_SUCCESS"
    ) {
      setUploadImagesData([]);
      setSelectedImagesStore([]);
      let catsData: any[] =
        pageProps.getProductMetaDataRequest.request_data.response.categories;

      let catFormated: any[] = catsData.map((each: any) => {
        return { label: each?.name, value: each?.name };
      });

      setAllCatsList(catFormated);
    }
  }, [pageProps?.getProductMetaDataRequest?.request_status]);

  useEffect(() => {
    if (!showImagesModal) {
      setSelectedImagesStore(uploadImagesData);
    }
  }, [showImagesModal]);

  useEffect(() => {
    if (
      pageProps?.createStoreProductRequest?.request_status ===
      "CREATE_PRODUCT_FAILURE"
    ) {
      showToast({
        title: "Unable to create product",
        description: getRequestErrorMessage(pageProps.createStoreProductRequest),
        type: "error",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [
    pageProps?.createStoreProductRequest?.request_status,
    pageProps?.createStoreProductRequest?.request_data?.error,
    showToast,
  ]);

  const removeProductImage = (url: any) => {
    let imagesBatch = selectedImagesStore;

    imagesBatch = imagesBatch.filter((itemData: any) => {
      return itemData.url !== url;
    });
    setUploadImagesData([]);
    setUploadImagesData((prev) => [...prev, ...imagesBatch]);

    setSelectedImagesStore(imagesBatch);
  };

  const hideProductImgModal = () => setShowImagesModal(false);

  const clearProductDiscountState = (setFieldValue: any) => {
    setFieldValue("addDiscount", false);
    setFieldValue("productDiscountPercent", "");
    setFieldValue("productDiscountPrice", "");
    setFieldValue("productDiscountStart", "");
    setFieldValue("productDiscountEnd", "");
    onStartChange(undefined);
    onEndChange(undefined);
  };

  const openVariantModal = (nextProductName: string) => {
    if (!nextProductName.replace(/\s+/g, " ").trim()) {
      showToast({
        title: "Fill a product name",
        description: "Add a product name before managing variants.",
        type: "error",
      });
      return;
    }

    setShowAddEditVariantPopup(true);
  };

  const handleSubmitProduct = (values: any, helpers: any) => {
    let loggedAccountInfo: any =
      localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    let formattedStart: any, formattedEnd: any;

    if (startDate && endDate) {
      formattedStart = new Date(startDate.toISOString());
      formattedStart.setDate(formattedStart.getDate());
      formattedStart = formattedStart.toISOString();

      formattedEnd = new Date(endDate.toISOString());
      formattedEnd.setDate(formattedEnd.getDate());
      formattedEnd = formattedEnd.toISOString();
    }

    const chosenCats = allCatsSelected.map((cat: any) => cat.value);
    const hasVariantModeEnabled = values.addVariant === true;
    const activeVariants = hasVariantModeEnabled ? variants : [];
    const variantSelectionError =
      values.addVariant && activeVariants.length === 0
        ? "Add at least one variant before saving this product"
        : null;
    const productDraft = {
      storeId: loggedAccountInfo.selectedStore.id,
      name: values.productName,
      categories: chosenCats,
      description: values.productDesc,
      sizePerUnit: parseFloat(values.productSize.replace(/,/g, "")),
      availableQuantity: parseInt(values.productQty),
      unitOfMeasureId: parseInt(values.productUnit),
      priceAmount: parseMoneyInput(values.productPrice) ?? 0,
      isTaxable: isTaxableOption,
      isReturnable: values.eligibleForReturn,
      returnPeriod: values.eligibleForReturn
        ? values.eligibleForReturnOption
        : undefined,
      discountPriceAmount:
        !hasVariantModeEnabled && values.addDiscount
          ? parseMoneyInput(values.productDiscountPrice)
          : undefined,
      discountStartDate: formattedStart,
      discountEndDate: formattedEnd,
      wholesaleProduct,
      minimumOrderQuantity: wholesaleProduct && values.minimumOrderQuantity
        ? parseInt(values.minimumOrderQuantity)
        : undefined,
      availability: availability !== "0" ? availability : undefined,
      orderCutOffDate:
        wholesaleProduct && availability === "2" && orderCutOffDate
          ? orderCutOffDate.toISOString()
          : undefined,
      expectedFulfillmentDate:
        wholesaleProduct && availability === "2" && expectedAvailabilityDate
          ? expectedAvailabilityDate.toISOString()
          : undefined,
      selectedImages: selectedImagesStore,
      attributes: hasVariantModeEnabled ? attributes : [],
      variants: activeVariants,
      hasVariantsEnabled: hasVariantModeEnabled,
      originalProductType: 0,
    };
    const submissionErrors = getProductSubmissionErrors(productDraft);
    const allSubmissionErrors = variantSelectionError
      ? Array.from(new Set([variantSelectionError, ...submissionErrors]))
      : submissionErrors;

    setShowCatError(chosenCats.length === 0);
    setSchemaErrors(allSubmissionErrors);

    if (allSubmissionErrors.length > 0) {
      return;
    }

    const payload = buildProductPayload(productDraft);

    addNewProduct({ pageProps, payload });
  };

  let detailsValidationSchema = Yup.object().shape({
    productName: Yup.string().required("Required"),
    productPrice: Yup.string().test(
      "product-price-required",
      "Required",
      (value, context) => {
        if (context.parent?.addVariant === true) {
          return true;
        }

        return !!value;
      },
    ),
    productSize: Yup.string().required("Required"),
    productQty: Yup.string().required("Required"),
    productUnit: Yup.string().required("Required"),
    productTags: Yup.string(),
    addDiscount: Yup.boolean(),
    productDiscountPercent: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountPrice: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountStart: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountEnd: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    wholesaleProduct: Yup.boolean(),
    minimumOrderQuantity: Yup.number().when("wholesaleProduct", {
      is: (wholesaleProduct: boolean) => wholesaleProduct === true,
      then: Yup.number().required(),
    }),
    available: Yup.string().matches(/^(1|2|0)$/),
    orderCutOffDate: Yup.string().when(["wholesaleProduct", "available"], {
      is: (wholesaleProduct: boolean, available: string) =>
        wholesaleProduct === true && available === "2",
      then: Yup.string().required("Order cut-off date is required"),
    }),
    expectedAvailabilityDate: Yup.string().when(["wholesaleProduct", "available"], {
      is: (wholesaleProduct: boolean, available: string) =>
        wholesaleProduct === true && available === "2",
      then: Yup.string().required("Expected availability date is required"),
    }),
    addVariant: Yup.boolean(),
    eligibleForReturn: Yup.boolean(),
    eligibleForReturnOption: Yup.string().when("eligibleForReturn", {
      is: (eligbleForReturn: boolean) => eligbleForReturn === true,
      then: Yup.string().matches(/^(1|2|0)$/),
    }),
    productDesc: Yup.string().required("Required"),
  });

  let initialValues: any = {
    productName: "",
    productPrice: "",
    productSize: "",
    productQty: "",
    productUnit: "",
    productStatus: "",
    productDesc: "",
    productDiscountPercent: "",
    productDiscountPrice: "",
    productDiscountStart: "",
    productDiscountEnd: "",
    startDate: "",
    endDate: "",
    addDiscount: false,
    wholesaleProduct: false,
    minimumOrderQuantity: "",
    available: "0",
    orderCutOffDate: "",
    expectedAvailabilityDate: "",
    addVariant: false,
    eligibleForReturnOption: "0",
    eligibleForReturn: false,
  };

  return (
    <div className="inapp-content">
      <div className="page-content form-page">
        {/* {showImagesModal && <ProductImagePop />} */}
        {showImagesModal && (
          <ImageDrawer
            pageProps={pageProps}
            showDrawer={showImagesModal}
            catListItems={catListItems}
            onClose={hideProductImgModal}
            selectedImages={selectedImagesStore}
            title="Add product image"
            applyButtonLabel="Add to Product"
            onApply={(images: any[]) => {
              setUploadImagesData(images);
              setSelectedImagesStore(images);
              setShowImagesModal(false);
            }}
          />
        )}
        {screenResolution?.width <= 767 && (
          <div className="mobile_back_nav">
            <div
              className="left-nav"
              onClick={() => history.replace("/app/my-products")}
            >
              {" "}
              <img src={LeftArrow} alt="" />{" "}
            </div>
            <div className="back_nav_txt">Back to Products</div>
          </div>
        )}

        {pageProps.getProductMetaDataRequest.request_status ===
          "GET_PRODUCT_META_SUCCESS" &&
          allCatsList.length >= 1 && (
            <div className="product-form">
              {screenResolution?.width <= 767 && (
                <div className="other-item-wrap">
                  <div className="heading-text">New Product</div>
                  <div className="heading-msg">
                    Kindly add a new product to your store by filling out the
                    necessary information below
                  </div>
                </div>
              )}
              <Formik
                initialValues={initialValues}
                validationSchema={detailsValidationSchema}
                onSubmit={handleSubmitProduct}
              >
                {(props: FormikProps<any>) => {
                  const {
                    values,
                    touched,
                    errors,
                    setFieldTouched,
                    handleChange,
                    setFieldValue,
                  } = props;
                  const hasVariantModeEnabled = values.addVariant === true;
                  return (
                    <Form>
                      <div className="form-wrap">
                        <div className="right-product-form">
                          <div className="product-images-container">
                            <div
                              className={
                                selectedImagesStore.length >= 1
                                  ? "image-control"
                                  : "image-control full"
                              }
                            >
                              <div className="images-label">Product image</div>
                              <div
                                className="product-images"
                                onClick={() => {
                                  let allCatData: any = [];
                                  pageProps.getProductMetaDataRequest.request_data.response.categories.forEach(
                                    (eachCat: any) => {
                                      allCatData.push({
                                        value: eachCat.name,
                                        label: eachCat.name,
                                      });
                                    },
                                  );
                                  imagesChosen.length = 1;
                                  setCatListItems(allCatData);
                                  let payload = `page=1&size=${sizeofFetch}`;
                                  getImagesGallery({ pageProps, payload });

                                  setShowImagesModal(true);
                                }}
                              >
                                <div className="upload-wrap-content">
                                  <img src={AddImg} alt="" />
                                  <div className="upload-txt">
                                    Check <span>MamiMarkets Gallery</span> or{" "}
                                    <span>Upload from your device</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {selectedImagesStore.length >= 1 && (
                              // (!showImagesModal && selectedImagesStore.length >= 1) &&
                              <div className="all-images-chosen">
                                {selectedImagesStore.map(
                                  (eachImage: any, index: any) => {
                                    return (
                                      <div
                                        className="product-image-wrap"
                                        key={index}
                                      >
                                        <div className="image-actions">
                                          <div className="select-cover">
                                            <input
                                              type="radio"
                                              name="cover-image-select"
                                            />
                                          </div>
                                          <div
                                            className="deleteicon"
                                            onClick={() =>
                                              removeProductImage(eachImage.url)
                                            }
                                          >
                                            <img
                                              src={TrashIcon}
                                              alt=""
                                              className=""
                                            />
                                          </div>
                                        </div>
                                        {/* <img src={eachImage.url} alt="" /> */}
                                        <div
                                          className="product-image-item"
                                          key={index}
                                        // style={{
                                        //     backgroundImage: `url(${eachImage.url})`
                                        // }}
                                        >
                                          <img src={eachImage.url} alt="" />
                                        </div>
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            )}
                          </div>
                          <div className="uploads-msg">
                            Ensure you use high-quality images that clearly
                            showcase the product. Also note that pictures must
                            be in 450 x 450 dimension. Max file size of 5mb.
                          </div>
                          <div className="form-group thin-bordered-box">
                            <div className="tax-label">
                              Is this product taxable?{" "}
                              <span>Learn more</span>{" "}
                            </div>
                            <div className="all_options">
                              <div className="an_option">
                                <span
                                  className={` custom_radio  ${isTaxableOption ? "selected_option" : ""
                                    }`}
                                >
                                  <input
                                    onChange={(e) => setIsTaxable(true)}
                                    name="check_taxable"
                                    type="radio"
                                    id="isTaxable"
                                    value="isTaxable"
                                  />
                                </span>
                                <label htmlFor="isTaxable">
                                  <span>Yes</span>
                                </label>
                              </div>
                              <div className="an_option">
                                <span
                                  className={`custom_radio ${!isTaxableOption ? "selected_option" : ""
                                    }`}
                                >
                                  <input
                                    onChange={(e) => setIsTaxable(false)}
                                    name="check_taxable"
                                    type="radio"
                                    id="notTaxable"
                                    value="notTaxable"
                                  />
                                </span>
                                <label htmlFor="notTaxable">
                                  <span>No</span>
                                </label>
                              </div>
                            </div>
                            <br />
                            <div
                              className={
                                errors.productTags && touched.productTags
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <label
                                htmlFor="productTags"
                                className="tax-label"
                              >
                                Product tags (optional)
                                <ErrorMessage
                                  name="productTags"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field
                                value={values.productTags}
                                name="productTags"
                                id="productTags"
                                type="text"
                                autoComplete="off"
                                onChange={handleChange}
                                className={`input-wrap inapp-input ${errors.productTags && touched.productTags
                                  ? "is-invalid-input "
                                  : !errors.productTags &&
                                    values.productTags !== ""
                                    ? "valid-input"
                                    : ""
                                  }`}
                              ></Field>
                              <div className="tax-label">
                                Suggested: <span>perishable</span>,{" "}
                                <span>nutritious</span>, <span>delicious</span>
                              </div>
                              {/* <small className="help-text">Maximum of 50 characters</small> */}
                            </div>
                          </div>
                          <br />
                          {screenResolution?.width >= 768 && (
                            <>
                              <div className="add-discount-wrap">
                                <Field
                                  onChange={handleChange}
                                  type="checkbox"
                                  name="addDiscount"
                                  id="addDiscount"
                                  disabled={hasVariantModeEnabled}
                                />
                                <label htmlFor="addDiscount">
                                  Add a discount
                                </label>
                              </div>
                              {values.addDiscount === true &&
                                !hasVariantModeEnabled && (
                                <div className="discount-wrap">
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPercent &&
                                            touched.productDiscountPercent
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPercent">
                                          Discount %
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPercent"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {!values.productPrice && (
                                            <span className="price-info-txt">
                                              (Enter original price)
                                            </span>
                                          )}
                                        </label>

                                        <Field
                                          // value={values.productDiscountPercent}
                                          disabled={
                                            !values.productPrice || hasVariantModeEnabled
                                          }
                                          value={allowNumbersOnly(
                                            values.productDiscountPercent,
                                            3,
                                          )}
                                          name="productDiscountPercent"
                                          type="text"
                                          placeholder="Discount %"
                                          // onChange={handleChange}
                                          onChange={(e: any) => {
                                            let valueSet: any =
                                              numberWithCommas(e.target.value);

                                            if (
                                              parseFloat(valueSet) <= 100 ||
                                              e.target.value === ""
                                            ) {
                                              setFieldTouched(
                                                "productDiscountPercent",
                                                true,
                                                true,
                                              );
                                              setFieldValue(
                                                "productDiscountPercent",
                                                valueSet,
                                              );

                                              setFieldValue(
                                                "productDiscountPrice",
                                                calculateDiscountedPrice(
                                                  values.productPrice,
                                                  valueSet,
                                                ),
                                              );
                                            }
                                          }}
                                          className={`input-wrap inapp-input ${errors.productDiscountPercent &&
                                            touched.productDiscountPercent
                                            ? "is-invalid-input "
                                            : !errors.productDiscountPercent &&
                                              values.productDiscountPercent !==
                                              ""
                                              ? "valid-input"
                                              : ""
                                            }`}
                                        ></Field>
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPrice &&
                                            touched.productDiscountPrice
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPrice">
                                          New price
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPrice"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {!values.productPrice && (
                                            <span className="price-info-txt">
                                              (Enter original price)
                                            </span>
                                          )}
                                        </label>

                                        <div className="price-wrap">
                                          <span className="currency-pre">
                                            $
                                          </span>
                                          <Field
                                            value={numberWithCommas(
                                              values.productDiscountPrice,
                                            )}
                                            name="productDiscountPrice"
                                            type="text"
                                            disabled={
                                              !values.productPrice || hasVariantModeEnabled
                                            }
                                            onChange={(e: any) => {
                                              let valueSet: any =
                                                numberWithCommas(
                                                  e.target.value,
                                                );
                                              setFieldTouched(
                                                "productDiscountPrice",
                                                true,
                                                true,
                                              );

                                              setFieldValue(
                                                "productDiscountPrice",
                                                valueSet,
                                              );

                                              if (
                                                (parseMoneyInput(valueSet) ?? 0) >=
                                                (parseMoneyInput(values.productPrice) ?? 0)
                                              ) {
                                                setIsDiscountMore(true);
                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  "",
                                                );
                                              } else {
                                                setIsDiscountMore(false);
                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  calculateDiscountPercent(
                                                    values.productPrice,
                                                    valueSet,
                                                  ),
                                                );
                                              }
                                              // setFieldError
                                            }}
                                            // onChange={handleChange}
                                            className={`input-wrap inapp-input ${errors.productDiscountPrice &&
                                              touched.productDiscountPrice
                                              ? "is-invalid-input "
                                              : !errors.productDiscountPrice &&
                                                values.productDiscountPrice !==
                                                ""
                                                ? "valid-input"
                                                : ""
                                              }`}
                                          ></Field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountStart &&
                                            touched.productDiscountStart
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountStart">
                                          Start date
                                          <ErrorMessage
                                            name="productDiscountStart"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>

                                        <DatePicker
                                          selected={startDate}
                                          onChange={(date: any) => {
                                            onStartChange(date);
                                            setFieldTouched(
                                              "productDiscountStart",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountStart",
                                              date ? date.toISOString() : "",
                                            );
                                          }}
                                          minDate={new Date()}
                                          name="productDiscountStart"
                                          // maxDate={new Date()}
                                          placeholderText="Select start date"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountEnd &&
                                            touched.productDiscountEnd
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountEnd">
                                          End date
                                          <ErrorMessage
                                            name="productDiscountEnd"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>
                                        <DatePicker
                                          selected={endDate}
                                          onChange={(date: any) => {
                                            onEndChange(date);
                                            setFieldTouched(
                                              "productDiscountEnd",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountEnd",
                                              date ? date.toISOString() : "",
                                            );
                                          }}
                                          name="productDiscountEnd"
                                          minDate={new Date()}
                                          // maxDate={new Date()}
                                          placeholderText="Select end date"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="product-cta">
                                <button
                                  // disabled={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1}
                                  disabled={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                    allCatsSelected.length < 1 ||
                                    selectedImagesStore.length < 1
                                  }
                                  className={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                      allCatsSelected.length < 1 ||
                                      selectedImagesStore.length < 1
                                      ? "btn btn-disabled"
                                      : "btn"
                                  }
                                >
                                  {/* className={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1 ? "btn btn-disabled" : "btn"}> */}
                                  {pageProps.createStoreProductRequest
                                    .is_request_processing
                                    ? "Please wait..."
                                    : "Add Product"}
                                  {/* {` imgs ${selectedImagesStore.length}`}
                                                {` cats ${selecteCatsStore.length}`} */}
                                </button>
                              </div>
                            </>
                          )}
                          {pageProps?.createStoreProductRequest
                            ?.request_status &&
                            pageProps.createStoreProductRequest
                              .request_status === "CREATE_PRODUCT_FAILURE" && (
                              <AlertMsg
                                type="error"
                                message={getRequestErrorMessage(
                                  pageProps.createStoreProductRequest,
                                )}
                              />
                            )}
                          {showCatError && (
                            <AlertMsg
                              type="error"
                              message="Select product category"
                            />
                          )}
                          {schemaErrors.length > 0 && (
                            <AlertMsg
                              type="error"
                              message={schemaErrors.join(", ")}
                            />
                          )}
                        </div>
                        <div className="product-info">
                          <div className="form-group thin-bordered-box">
                            <div
                              className={
                                errors.productName && touched.productName
                                  ? "invalid-input-wrap"
                                  : ""
                              }
                            >
                              <label htmlFor="productName">
                                Product name
                                <ErrorMessage
                                  name="productName"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <Field
                                value={values.productName}
                                name="productName"
                                id="productName"
                                autoComplete="off"
                                type="text"
                                placeholder="Enter product name here"
                                onChange={(event: any) => {
                                  handleChange(event);
                                  setProductNameForVariants(event.target.value);
                                }}
                                className={`input-wrap inapp-input ${errors.productName && touched.productName
                                  ? "is-invalid-input "
                                  : !errors.productName &&
                                    values.productName !== ""
                                    ? "valid-input"
                                    : ""
                                  }`}
                              ></Field>
                              <small className="help-text">
                                Maximum of 50 characters
                              </small>
                            </div>
                            <br />
                            <div className="">
                              {/* <div className={errors.productName && touched.productName ? "invalid-input-wrap" : ""}> */}
                              <label htmlFor="productName">Category</label>
                              <MultiSelect
                                options={allCatsList}
                                value={allCatsSelected}
                                onChange={setAllCatsSelected}
                                labelledBy="Select"
                                hasSelectAll={false}
                                className="cat-select-wrap"
                              // isLoading={true}
                              />
                            </div>

                            <div className="two-sided for_pricing">
                              <div className="form-group pricing_wrap">
                                <div
                                  className={
                                    errors.productPrice && touched.productPrice
                                      ? "invalid-input-wrap "
                                      : ""
                                  }
                                >
                                  <label htmlFor="productPrice">
                                    {wholesaleProduct ? "Wholesale Price" : "Price"}
                                    <ErrorMessage
                                      name="productPrice"
                                      className="form-input-error"
                                      component="span"
                                    />
                                  </label>

                                  <div className="price-wrap">
                                    <span className="currency-pre">$</span>
                                    <Field
                                      value={numberWithCommas(
                                        values.productPrice,
                                      )}
                                      name="productPrice"
                                      type="text"
                                      placeholder=" Price"
                                      autoComplete="off"
                                      disabled={hasVariantModeEnabled}
                                      // onChange={handleChange}
                                      onChange={(e: any) => {
                                        let valueSet: any = numberWithCommas(
                                          e.target.value,
                                        );
                                        setFieldTouched(
                                          "productPrice",
                                          true,
                                          true,
                                        );

                                        setFieldValue("productPrice", valueSet);
                                        if (!e.target.value) {
                                          setFieldValue(
                                            "productDiscountPercent",
                                            "",
                                          );
                                          setFieldValue(
                                            "productDiscountPrice",
                                            "",
                                          );
                                        } else {
                                          if (values.productDiscountPercent) {
                                            setFieldValue(
                                              "productDiscountPrice",
                                              calculateDiscountedPrice(
                                                valueSet,
                                                values.productDiscountPercent,
                                              ),
                                            );
                                          }
                                        }
                                      }}
                                      className={`input-wrap inapp-input ${hasVariantModeEnabled
                                        ? "disabled-price-input "
                                        : ""
                                        }${errors.productPrice &&
                                        touched.productPrice
                                        ? "is-invalid-input "
                                        : !errors.productPrice &&
                                          values.productPrice !== ""
                                          ? "valid-input"
                                          : ""
                                        }`}
                                    ></Field>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group qty_only_wrap">
                                <label htmlFor="productSize">
                                  Size
                                  <ErrorMessage
                                    name="productSize"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>
                                <div
                                  className={
                                    (errors.productSize &&
                                      touched.productSize) ||
                                      errors.productUnit
                                      ? "invalid-input qty-input"
                                      : "qty-input"
                                  }
                                >
                                  <div className="input-item">
                                    <Field
                                      value={numberWithCommas(
                                        values.productSize,
                                      )}
                                      name="productSize"
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Size"
                                      onChange={handleChange}
                                      className={` ${errors.productSize &&
                                        touched.productSize
                                        ? "is-invalid-input "
                                        : !errors.productSize &&
                                          values.productSize !== ""
                                          ? "valid-input"
                                          : ""
                                        }`}
                                    ></Field>
                                  </div>
                                  <Field
                                    value={values.productUnit}
                                    name="productUnit"
                                    as="select"
                                    autoComplete="off"
                                    onChange={handleChange}
                                    placeholder=""
                                    className={`${errors.productUnit && touched.productUnit
                                      ? "is-invalid-input"
                                      : !errors.productUnit &&
                                        values.productUnit !== ""
                                        ? "valid-input"
                                        : ""
                                      }`}
                                  >
                                    <option value="">size</option>
                                    {pageProps.getProductMetaDataRequest.request_data.response.units.map(
                                      (eachUnit: any, index: any) => {
                                        return (
                                          <option
                                            key={index}
                                            value={eachUnit.id}
                                          >
                                            {eachUnit.unit}
                                          </option>
                                        );
                                      },
                                    )}
                                  </Field>
                                </div>
                              </div>
                            </div>

                            <div className="form-group">
                              <label htmlFor="productQty">
                                Quantity Available
                                <ErrorMessage
                                  name="productQty"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>
                              <div
                                className={
                                  errors.productQty && touched.productQty
                                    ? "invalid-input-wrap"
                                    : ""
                                }
                              >
                                <Field
                                  value={allowNumbersOnly(values.productQty)}
                                  name="productQty"
                                  type="text"
                                  autoComplete="off"
                                  placeholder="Enter Quantity"
                                  onChange={handleChange}
                                  className={`input-wrap inapp-input ${errors.productQty && touched.productQty
                                    ? "is-invalid-input "
                                    : !errors.productQty &&
                                      values.productQty == ""
                                      ? "valid-input"
                                      : ""
                                    }`}
                                ></Field>
                              </div>
                            </div>

                            <div className="form-group">
                              <div>
                                <label htmlFor="productDesc">
                                  Description
                                  <ErrorMessage
                                    name="productDesc"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>
                                <Field name="productDesc">
                                  {({ field, form }: any) => (
                                    <ReactQuill
                                      value={field.value}
                                      onChange={(val) =>
                                        form.setFieldValue(field.name, val)
                                      }
                                      onBlur={(_, __, quill) => {
                                        const plainText = quill
                                          .getText()
                                          .trim();
                                        if (plainText.length === 0)
                                          form.setFieldValue(field.name, "");
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      modules={modules}
                                      formats={formats}
                                      className={`custom-quill ${form.errors.productDesc &&
                                        form.touched.productDesc
                                        ? "is-invalid-input"
                                        : !form.errors.productDesc &&
                                          field.value
                                          ? "valid-input"
                                          : ""
                                        }`}
                                    />
                                  )}
                                </Field>
                                <small className="help-text">
                                  Maximum of 500 characters
                                </small>
                              </div>
                            </div>

                          </div>
                          <div className="form-group variant-section-full-width">
                            <div className="form-group thin-bordered-box">
                              <div className="wholesale-available-product-box">
                                <div className="whosale-product-box">
                                  <div className="checkbox-radio-wrap">
                                    <label>
                                      <Field
                                        onChange={(e: any) => {
                                          setWholesaleProduct(e.target.checked);
                                          setFieldValue("wholesaleProduct", e.target.checked);
                                        }}
                                        checked={wholesaleProduct}
                                        type="checkbox"
                                        name="wholesaleProduct"
                                        id="wholesaleProduct-top"
                                      />
                                      This is a wholesale product
                                    </label>
                                  </div>

                                  {wholesaleProduct && (
                                    <div className="min-order-qty-group">
                                      <div
                                        className={
                                          errors.minimumOrderQuantity &&
                                            touched.minimumOrderQuantity
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <Field
                                          type="number"
                                          id="minimumOrderQuantity-top"
                                          name="minimumOrderQuantity"
                                          min={1}
                                          placeholder="Minimum order quantity"
                                          className={`input-wrap inapp-input ${errors.minimumOrderQuantity &&
                                            touched.minimumOrderQuantity
                                            ? "is-invalid-input "
                                            : !errors.minimumOrderQuantity &&
                                              values.minimumOrderQuantity !==
                                              ""
                                              ? "valid-input"
                                              : ""
                                            }`}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="availability-group">
                                  <span className="availability-label">
                                    Availability
                                  </span>
                                  <div className="checkbox-radio-wrap">
                                    <label>
                                      <Field
                                        onChange={(e: any) => {
                                          setAvailability(e.target.value);
                                          setFieldValue("available", e.target.value);
                                        }}
                                        type="radio"
                                        name="available"
                                        id="available-Pickup"
                                        value="1"
                                        checked={availability === "1"}
                                      />
                                      In stock
                                    </label>
                                  </div>
                                  <div className="checkbox-radio-wrap">
                                    <label>
                                      <Field
                                        onChange={(e: any) => {
                                          setAvailability(e.target.value);
                                          setFieldValue("available", e.target.value);
                                        }}
                                        type="radio"
                                        name="available"
                                        id="available-Preorder"
                                        value="2"
                                        checked={availability === "2"}
                                      />
                                      Pre-order
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {wholesaleProduct && availability === "2" && (
                                <div className="wholesale-details-row">
                                  <div className="pre-order-dates-group">
                                    <div className="form-group">
                                      <label htmlFor="orderCutOffDate">
                                        Order cut-off date
                                        <span
                                          className="info-icon-wrapper"
                                          onMouseEnter={() => setShowOrderCutoffTooltip(true)}
                                          onMouseLeave={() => setShowOrderCutoffTooltip(false)}
                                          aria-label="Order cut-off date info"
                                        >
                                          <InfoIcon />
                                        </span>
                                      </label>
                                      {showOrderCutoffTooltip && (
                                        <div className="info-tooltip">
                                          <p>
                                            NB: Customers cannot pre-order this
                                            item after the order cut-off date.{" "}
                                          </p>
                                        </div>
                                      )}
                                      <DatePicker
                                        selected={orderCutOffDate}
                                        onChange={(date: any) => {
                                          setOrderCutOffDate(date);
                                          setFieldTouched("orderCutOffDate", true);
                                          setFieldValue(
                                            "orderCutOffDate",
                                            date ? date.toISOString() : "",
                                          );
                                        }}
                                        minDate={new Date()}
                                        name="orderCutOffDate"
                                        placeholderText="Select order cut-off date"
                                        className="input-wrap inapp-input"
                                      />
                                      <ErrorMessage
                                        name="orderCutOffDate"
                                        className="form-input-error"
                                        component="span"
                                      />
                                    </div>
                                    <div className="form-group">
                                      <label htmlFor="expectedAvailabilityDate">
                                        Expected delivery date
                                        <span
                                          className="info-icon-wrapper"
                                          onMouseEnter={() => setShowExpectedAvailabilityTooltip(true)}
                                          onMouseLeave={() => setShowExpectedAvailabilityTooltip(false)}
                                          aria-label="Expected delivery date info"
                                        >
                                          <InfoIcon />
                                        </span>
                                      </label>
                                      {showExpectedAvailabilityTooltip && (
                                        <div className="info-tooltip">
                                          <p>
                                            The date this item is expected to arrive in your store.
                                          </p>
                                        </div>
                                      )}
                                      <DatePicker
                                        selected={expectedAvailabilityDate}
                                        onChange={(date: any) => {
                                          setExpectedAvailabilityDate(date);
                                          setFieldTouched(
                                            "expectedAvailabilityDate",
                                            true,
                                          );
                                          setFieldValue(
                                            "expectedAvailabilityDate",
                                            date ? date.toISOString() : "",
                                          );
                                        }}
                                        minDate={orderCutOffDate || new Date()}
                                        name="expectedAvailabilityDate"
                                        placeholderText="Select expected availability date"
                                        className="input-wrap inapp-input"
                                      />
                                      <ErrorMessage
                                        name="expectedAvailabilityDate"
                                        className="form-input-error"
                                        component="span"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                          <div className="two-sided">
                            <div className="form-group thin-bordered-box variant-section-full-width">
                              <div className="eligible-btn-wrapper">
                                <div className="checkbox-radio-wrap">
                                  <label>
                                    <Field
                                      onChange={handleChange}
                                      type="checkbox"
                                      name="eligibleForReturn"
                                      id="eligibleForReturn-top"
                                    />
                                    Eligible for return
                                  </label>
                                </div>

                                <Field
                                  as="select"
                                  className="input-wrap select"
                                  disabled={!values.eligibleForReturn}
                                  name="eligibleForReturnOption"
                                >
                                  <option value="0">Select an option</option>
                                  <option value="0">For 3 days.</option>
                                  <option value="1">For 7 days.</option>
                                </Field>
                              </div>

                            </div>
                            <div className="form-group thin-bordered-box variant-section-full-width">
                              <div className="variant-btn-wrapper">
                                <div className="checkbox-radio-wrap">
                                  <label className="variant-toggle-label">
                                    <Field
                                      onChange={(event: any) => {
                                        handleChange(event);

                                        if (event.target.checked) {
                                          clearProductDiscountState(
                                            setFieldValue,
                                          );
                                          return;
                                        }

                                        setAttributes([]);
                                        setVariants([]);
                                        setEditingVariantIndex(null);
                                        setVariantToEdit(null);
                                        setShowAddEditVariantPopup(false);
                                      }}
                                      type="checkbox"
                                      name="addVariant"
                                      id="addVariant-top"
                                    />
                                    Add/edit variants
                                    {variants.length > 0 ? (
                                      <span className="variant-count-badge">
                                        {variants.length}
                                      </span>
                                    ) : null}
                                  </label>
                                </div>
                                <div>
                                  <button
                                    type="button"
                                    className="input-wrap"
                                    disabled={!values.addVariant}
                                    onClick={() =>
                                      openVariantModal(values.productName)
                                    }
                                  >
                                    + Add variants option
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          {screenResolution?.width <= 767 && (
                            <>
                              <div className="add-discount-wrap">
                                <Field
                                  onChange={handleChange}
                                  type="checkbox"
                                  name="addDiscount"
                                  id="addDiscount"
                                  disabled={hasVariantModeEnabled}
                                />
                                <label htmlFor="addDiscount">
                                  Add a discount
                                </label>
                              </div>
                              {values.addDiscount === true &&
                                !hasVariantModeEnabled && (
                                <div className="discount-wrap">
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPercent &&
                                            touched.productDiscountPercent
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPercent">
                                          Discount %
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPercent"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {/* {!values.productPrice &&
                                                                                    <span className="price-info-txt">(Enter original price)</span>
                                                                                } */}
                                        </label>

                                        <Field
                                          // value={values.productDiscountPercent}
                                          disabled={
                                            !values.productPrice || hasVariantModeEnabled
                                          }
                                          value={allowNumbersOnly(
                                            values.productDiscountPercent,
                                            3,
                                          )}
                                          name="productDiscountPercent"
                                          type="text"
                                          placeholder="Discount %"
                                          // onChange={handleChange}
                                          onChange={(e: any) => {
                                            let valueSet: any =
                                              numberWithCommas(e.target.value);

                                            if (
                                              parseFloat(valueSet) <= 100 ||
                                              e.target.value === ""
                                            ) {
                                              setFieldTouched(
                                                "productDiscountPercent",
                                                true,
                                                true,
                                              );
                                              setFieldValue(
                                                "productDiscountPercent",
                                                valueSet,
                                              );

                                              setFieldValue(
                                                "productDiscountPrice",
                                                calculateDiscountedPrice(
                                                  values.productPrice,
                                                  valueSet,
                                                ),
                                              );
                                            }
                                          }}
                                          className={`input-wrap inapp-input ${errors.productDiscountPercent &&
                                            touched.productDiscountPercent
                                            ? "is-invalid-input "
                                            : !errors.productDiscountPercent &&
                                              values.productDiscountPercent !==
                                              ""
                                              ? "valid-input"
                                              : ""
                                            }`}
                                        ></Field>
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountPrice &&
                                            touched.productDiscountPrice
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountPrice">
                                          New price
                                          {values.productPrice && (
                                            <ErrorMessage
                                              name="productDiscountPrice"
                                              className="form-input-error"
                                              component="span"
                                            />
                                          )}
                                          {/* {!values.productPrice &&
                                                                                    <span className="price-info-txt">(Enter original price)</span>
                                                                                } */}
                                        </label>

                                        <div className="price-wrap">
                                          <span className="currency-pre">
                                            $
                                          </span>
                                          <Field
                                            value={numberWithCommas(
                                              values.productDiscountPrice,
                                            )}
                                            name="productDiscountPrice"
                                            type="text"
                                            disabled={
                                              !values.productPrice || hasVariantModeEnabled
                                            }
                                            onChange={(e: any) => {
                                              let valueSet: any =
                                                numberWithCommas(
                                                  e.target.value,
                                                );
                                              setFieldTouched(
                                                "productDiscountPrice",
                                                true,
                                                true,
                                              );

                                              setFieldValue(
                                                "productDiscountPrice",
                                                valueSet,
                                              );

                                              if (
                                                (parseMoneyInput(valueSet) ?? 0) >=
                                                (parseMoneyInput(values.productPrice) ?? 0)
                                              ) {
                                                setIsDiscountMore(true);
                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  "",
                                                );
                                              } else {
                                                setIsDiscountMore(false);
                                                setFieldValue(
                                                  "productDiscountPercent",
                                                  calculateDiscountPercent(
                                                    values.productPrice,
                                                    valueSet,
                                                  ),
                                                );
                                              }
                                              // setFieldError
                                            }}
                                            // onChange={handleChange}
                                            className={`input-wrap inapp-input ${errors.productDiscountPrice &&
                                              touched.productDiscountPrice
                                              ? "is-invalid-input "
                                              : !errors.productDiscountPrice &&
                                                values.productDiscountPrice !==
                                                ""
                                                ? "valid-input"
                                                : ""
                                              }`}
                                          ></Field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="two-sided">
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountStart &&
                                            touched.productDiscountStart
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountStart">
                                          Start date
                                          <ErrorMessage
                                            name="productDiscountStart"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>

                                        <DatePicker
                                          selected={startDate}
                                          showIcon={true}
                                          onChange={(date: any) => {
                                            onStartChange(date);
                                            setFieldTouched(
                                              "productDiscountStart",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountStart",
                                              date ? date.toISOString() : "",
                                            );
                                          }}
                                          minDate={new Date()}
                                          name="productDiscountStart"
                                          // maxDate={new Date()}
                                          placeholderText="Select start date"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <div
                                        className={
                                          errors.productDiscountEnd &&
                                            touched.productDiscountEnd
                                            ? "invalid-input-wrap "
                                            : ""
                                        }
                                      >
                                        <label htmlFor="productDiscountEnd">
                                          End date
                                          <ErrorMessage
                                            name="productDiscountEnd"
                                            className="form-input-error"
                                            component="span"
                                          />
                                        </label>
                                        <DatePicker
                                          showIcon={true}
                                          selected={endDate}
                                          onChange={(date: any) => {
                                            onEndChange(date);
                                            setFieldTouched(
                                              "productDiscountEnd",
                                              true,
                                            );
                                            setFieldValue(
                                              "productDiscountEnd",
                                              date ? date.toISOString() : "",
                                            );
                                          }}
                                          name="productDiscountEnd"
                                          minDate={new Date()}
                                          // maxDate={new Date()}
                                          placeholderText="Select end date"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="product-cta">
                                <button
                                  // disabled={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1}
                                  disabled={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                    allCatsSelected.length < 1 ||
                                    selectedImagesStore.length < 1
                                  }
                                  className={
                                    pageProps.createStoreProductRequest
                                      ?.is_request_processing ||
                                      allCatsSelected.length < 1 ||
                                      selectedImagesStore.length < 1
                                      ? "btn btn-disabled"
                                      : "btn"
                                  }
                                >
                                  {/* className={pageProps.createStoreProductRequest?.is_request_processing || selecteCatsStore.length < 1 || selectedImagesStore.length < 1 ? "btn btn-disabled" : "btn"}> */}
                                  {pageProps.createStoreProductRequest
                                    .is_request_processing
                                    ? "Please wait..."
                                    : "Add Product"}
                                  {/* {` imgs ${selectedImagesStore.length}`}
                                                {` cats ${selecteCatsStore.length}`} */}
                                </button>
                              </div>
                            </>
                          )}

                          {/* {pageProps?.createStoreProductRequest?.request_status
                                                    && pageProps.createStoreProductRequest.request_status === "CREATE_PRODUCT_FAILURE" &&
                                                    <AlertMsg type="error" message={pageProps.createStoreProductRequest?.request_data.error} />
                                                }
                                                {showCatError &&
                                                    <AlertMsg type="error" message="Select product category" />
                                                } */}
                          {/* {selecteCatsStore.map((item: any) => {
                                                    return <pre>{item}</pre>;
                                                })} */}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          )}
        {pageProps.getProductMetaDataRequest.request_status ===
          "GET_PRODUCT_META_PENDING" && <LoadingItem />}
        {showAddEditVariantPopup && (
          <ProductVarianceModal
            show={showAddEditVariantPopup}
            initialEditVariant={variantToEdit}
            editIndex={editingVariantIndex}
            onClose={() => {
              setShowAddEditVariantPopup(false);
              setEditingVariantIndex(null);
              setVariantToEdit(null);
            }}
            attributes={attributes}
            setAttributes={setAttributes}
            variants={variants}
            setVariants={setVariants}
            pageProps={pageProps}
            sizeOfFetch={sizeofFetch}
            productName={productNameForVariants}
          />
        )}
      </div>
    </div>
  );
};
